const crud = {
    add: 'add',
    edit: 'edit',
    details: 'details',
};
export const ApiRoutes = Object.freeze({
    api: {
        // host: "http://localhost:8989/",
        host: "https://api.sms.fluidehr.com/",
        get baseUrl() { return this.host + "api/v1/app/" },
        user: {
            login: "appLogin",
            logout: "appLogout",
            add: "appRegister",
            edit: "editUser",
            retrieveSingle: "getSingleUser",
            updateStatus: "updateStatus",
            bulkUpdateStatus: "bulk-update-status",
            regeneratePassword: "regeneratePassword",
            retrieve: "getUsers",
            delete: "deleteUser",
            forgotPassword: "forgotPassword",
            resetPassword: "resetPassword",
        },
        statistics: {
            all: "all-statistics",
            admin: "admin-statistics",
            staff: "staff-statistics",
            subAdmin: "subAdmin-statistics",
            owner: "owner-statistics",
            teacher: "teacher-statistics",
            learner: "learner-statistics"
        },
        learner: {
            add: "addLearner",
            edit: "editLearner",
            retrieve: "getLearners",
            retrieveSingle: "getSingleLearner",
            getRegisteredCourses: "getRegisteredCourses",
            delete: "deleteLearner",
            bulkDelete: "bulk-delete-learners",
            findByMatricule: "findByMatricule",
            transferClass: "transfer-learner-class",
            classTransferHistory: "learner-class-transfer-history",
            academicHistory: "learner-academic-history",
        },
        teacher: {
            add: "addTeacher",
            edit: "editTeacher",
            retrieve: "getTeachers",
            retrieveSingle: "getSingleTeacher",
            delete: "deleteTeacher",
            bulkDelete: "bulk-delete-teachers",
            generateIdCard: "generate-teacher-idcard"
        },
        school: {
            add: "addSchool",
            edit: "editSchool",
            retrieve: "getSchools",
            retrieveSingle: "getSingleSchool",
            delete: "deleteSchool",
            getSchoolOnline: "get-school",
            bulkDelete: "bulk-delete-schools"
        },
        academicYear: {
            add: "addAcademicYear",
            edit: "editAcademicYear",
            retrieve: "getAcademicYears",
            retrieveSingle: "getSingleAcademicYear",
            delete: "deleteAcademicYear",
            setActiveYear: "setActiveYear",
            bulkDelete: "bulk-delete-academic-years",
            promoteLearnersAtYearEnd: "promote-learners-at-year-end",
            duplicate: "duplicate-academic-year"
        },
        academicLevel: {
            add: "addAcademicLevel",
            edit: "editAcademicLevel",
            retrieve: "getAcademicLevels",
            retrieveSingle: "getSingleAcademicLevel",
            delete: "deleteAcademicLevel",
            bulkDelete: "bulk-delete-academic-levels"
        },
        assignment: {
            add: "addAssignment",
            edit: "editAssignment",
            retrieve: "getAssignments",
            retrieveSingle: "getSingleAssignment",
            delete: "deleteAssignment",
            bulkDelete: "bulk-delete-assignments",
            submit: "submitAssignment",
            grade: "gradeAssignment",
            upload: "upload-assignment-file",
            download: "download-assignment-file",
            overdue: "get-overdue-assignments"
        },
        evaluation: {
            add: "addEvaluation",
            edit: "editEvaluation",
            retrieve: "getEvaluations",
            retrieveSingle: "getSingleEvaluation",
            delete: "deleteEvaluation",
            bulkDelete: "bulk-delete-evaluations",
            rankLearners: "rankLearners",
            byTeacher: "getEvaluationsByTeacherId",
            courseEvaluationSheet: "course-evaluation-sheet",
            sequenceSheet: "sequence-sheet",
            sequenceEvaluations: "sequence-evaluations",
        },
        result: {
            downloadTeacherMarkSheet: "download-teacher-marks",
            downloadCourseMarkSheet: "download-course-marks",
            getTermPerformanceSummary: "get-term-performance-summary",
            downloadTermPerformanceSummary: "download-term-performance-summary",
            downloadClassPerformanceSummary: "download-class-performance-summary",
            downloadClassMasterSheet: "download-master-sheet",
            downloadReportCard: "download-report-card",
            downloadPromotionReport: "download-promotion-report",
            downloadClassReportCards: "download-class-report-cards",
            downloadMultiplePromotionReports: "download-multiple-promotion-reports",
            downloadClassroomPromotionReports: "download-classroom-promotion-reports",
            downloadSeriesCourseGradesPDF: "download-series-course-grades",
            processResults: "process-results"
        },
        course: {
            add: "addCourse",
            edit: "editCourse",
            retrieve: "getCourses",
            retrieveSingle: "getSingleCourse",
            delete: "deleteCourse",
            register: "registerCourses",
            registeredCourses: "registeredCourses",
            getAssignedCourses: "getAssignedCourses",
            courseList: "course-list",
            bulkDelete: "bulk-delete-courses",
            assignCourses: "assignCourses",
            unassignCourses: "unassignCourses",
            assignCourseToClassrooms: "assignCourseToClassrooms",
            assignCoursesToClassroom: "assignCoursesToClassroom",
            removeFromClassroom: "removeFromClassroom",
            setCreditValue: "setCreditValue"
        },
        classroom: {
            add: "addClassroom",
            edit: "editClassroom",
            retrieve: "getClassrooms",
            retrieveSingle: "getSingleClassroom",
            delete: "deleteClassroom",
            classList: "class-list",
            bulkDelete: "bulk-delete-classrooms",
            registerLearners: "register-learners",
            merge: 'classroom-merge',
            assignClassMaster: "assignClassMaster"
        },
        semester: {
            add: "addSemester",
            edit: "editSemester",
            retrieve: "getSemesters",
            retrieveSingle: "getSingleSemester",
            activeSemester: "activeSemester",
            delete: "deleteSemester",
            bulkDelete: "bulk-delete-semesters",
            setActiveSemester: "setActiveSemester"
        },
        sequence: {
            add: "addSequence",
            edit: "editSequence",
            retrieve: "getSequences",
            activeSequence: "activeSequence",
            retrieveSingle: "getSingleSequence",
            delete: "deleteSequence",
            bulkDelete: "bulk-delete-sequences",
            setActiveSequence: "setActiveSequence",
        },
        grade: {
            add: "addGrade",
            edit: "editGrade",
            courseAverage: "courseAverage",
            retrieve: "getGrades",
            retrieveSingle: "getSingleGrade",
            delete: "deleteGrade",
        },
        activity: {
            add: "addActivity",
            edit: "editActivity",
            retrieve: "getActivities",
            retrieveSingle: "getSingleActivity",
            delete: "deleteActivity",
            bulkDelete: "bulk-delete-activities"
        },
        task: {
            add: "addTask",
            edit: "editTask",
            retrieve: "getTasks",
            retrieveSingle: "getSingleTask",
            delete: "deleteTask",
            bulkDelete: "bulk-delete-tasks"
        },
        timeTable: {
            add: "addTimeTable",
            edit: "editTimeTable",
            retrieve: "getTimeTables",
            retrieveSingle: "getSingleTimeTable",
            delete: "deleteTimeTable",
            bulkDelete: "bulk-delete-time-tables",
            getTimeSlots: "getTimeSlots",
            editTimeSlot: "editTimeSlot",
            addTimeSlot: "addTimeSlot",
        },
        project: {
            add: "addProject",
            edit: "editProject",
            retrieve: "getProjects",
            retrieveSingle: "getSingleProject",
            delete: "deleteProject",
            bulkDelete: "bulk-delete-projects"
        },
        role: {
            add: "addRole",
            edit: "editRole",
            retrieve: "getRoles",
            retrieveSingle: "getSingleRole",
            delete: "deleteRole",
            bulkDelete: "bulk-delete-roles"
        },
        specialization: {
            add: "addSpecialization",
            edit: "editSpecialization",
            retrieve: "getSpecializations",
            retrieveSingle: "getSingleSpecialization",
            delete: "deleteSpecialization",
            bulkDelete: "bulk-delete-specializations"
        },
        series: {
            add: "addSeries",
            edit: "editSeries",
            retrieve: "getSeriess",
            retrieveSingle: "getSingleSeries",
            delete: "deleteSeries",
            bulkDelete: "bulk-delete-series"
        },
        department: {
            add: "addDepartment",
            edit: "editDepartment",
            retrieve: "getDepartments",
            retrieveSingle: "getSingleDepartment",
            delete: "deleteDepartment",
            bulkDelete: "bulk-delete-departments"
        },
        fees: {
            addFeeStructure: "addFeeStructure",
            editFeeStructure: "editFeeStructure",
            deleteFeeStructure: "deleteFeeStructure",
            retrieve: "getFeeStructures",
            retrieveSingle: "getSingleFeeStructure",
            feePayment: "fee-payment",
            feeReceipt: "fee-receipt",
            feeStatistics: "fee-statistics",
            learnerPayments: "learner-payments"
        },
        notification: {
            sendSMS: "sendSMS",
            sendEmail: "sendEmail",
            pull: "pullPushNotification"
        },
        preference: {
            add: "addPreference",
            edit: "editPreference",
            retrieve: "getPreferences",
            retrieveSingle: "getSinglePreference",
            delete: "deletePreference",
        },
        resource: {
            add: "addResource",
            edit: "editResource",
            retrieve: "getResources",
            retrieveSingle: "getSingleResource",
            delete: "deleteResource",
        },
        promotion: {
            promoteClass: "promote-class-learners",
            promoteSelected: "promote-selected-learners",
            promoteAll: "promote-all-school-learners",
            getHistory: "get-learner-promotion-history",
            getClassroomStatus: "get-classroom-promotion-status",
            reverse: "reverse-promotion",
            finalize: "finalize-promotions"
        },
        classroomProgression: {
            setProgression: "set-classroom-progression",
            getPath: "get-classroom-progression-path",
            getHierarchy: "get-classroom-progression-hierarchy",
            bulkSet: "bulk-set-classroom-progression",
            autoDetect: "auto-detect-classroom-progression"
        },
        permission: {
            add: "addPermission",
            edit: "editPermission",
            retrieve: "getPermissions",
            retrieveSingle: "getSinglePermission",
            delete: "deletePermission",
            all: "permissions",
            assign: "assignPermission",
            remove: "removePermission",
            bulkDelete: "bulk-delete-permissions"
        },
        fileUpload: {
            multiple: "multiple-files",
            single: "file-upload",
            files: "files-upload",
            anyFiles: "any-files",
        },
        transcript: {
            generate: "generate-transcript",
            bulkGenerate: "bulk-generate-transcripts",
            history: "get-transcript-history",
            download: "download-transcript"
        },
        customExam: {
            initializeTypes: "initialize-custom-exam-types",
            createExamType: "create-exam-type",
            getExamTypes: "get-exam-types",
            updateExamType: "update-exam-type",
            deleteExamType: "delete-exam-type",
            createCustomExam: "create-custom-exam",
            getCustomExams: "get-custom-exams",
            getCustomExamById: "get-custom-exam-by-id",
            updateCustomExam: "update-custom-exam",
            deleteCustomExam: "delete-custom-exam",
            generateResults: "generate-custom-exam-results",
            getResults: "get-custom-exam-results",
            generateCertificate: "generate-custom-exam-certificate",
            getStatistics: "get-custom-exam-statistics"
        },
        idCard: {
            generateLearner: "download-learner-idcard",
            generateTeacher: "download-teacher-idcard",
            bulkGenerateLearners: "download-bulk-learner-idcards",
            bulkGenerateTeachers: "download-bulk-teacher-idcards",
            generateClass: "download-class-idcards",
            download: "download-idcard"
        },
        lecture: {
            add: "addLecture",
            edit: "editLecture",
            retrieve: "getLectures",
            retrieveSingle: "getSingleLecture",
            delete: "deleteLecture",
            takeAttendance: "takeAttendance",
            uploadMaterial: "upload-lecture-material",
            downloadMaterial: "download-lecture-material",
            teacherLectures: "teacher-lectures",
            classroomLectures: "classroom-lectures",
            // Enhanced lecture routes
            getMaterials: "get-lecture-materials",
            deleteMaterial: "delete-lecture-material",
            addNote: "add-lecture-note",
            getNotes: "get-lecture-notes",
            updateNote: "update-lecture-note",
            deleteNote: "delete-lecture-note",
            trackProgress: "track-lecture-progress",
            getProgress: "get-lecture-progress",
            getLectureStats: "lecture-statistics"
        },
        bulkActions: {
            "bulk-import": "bulk-import"
        },
        pdf: {
            requestPdf: "request-pdf",
            getPdfStatus: "get-pdf-status",
            downloadPdf: "pdf-download",
            getPdfHealth: "get-pdf-health"
        },
        // Student Attendance Module
        attendance: {
            mark: "mark-attendance",
            markBulk: "mark-bulk-attendance",
            markByQr: "mark-attendance-qr",
            getByClassroom: "get-classroom-attendance",
            getByLearner: "get-learner-attendance",
            getByDate: "get-attendance-by-date",
            update: "update-attendance",
            delete: "delete-attendance",
            submitExcuse: "submit-attendance-excuse",
            approveExcuse: "approve-attendance-excuse",
            getDailySummary: "daily-attendance-summary",
            getWeeklyTrend: "attendance-weekly-trend",
            getReport: "attendance-report",
            getStats: "attendance-stats",
            getCalendar: "attendance-calendar",
            generateQr: "generate-attendance-qr",
            classroomStatus: "classroom-attendance-status"
        },
        // Staff Attendance Module
        staffAttendance: {
            checkIn: "staff-check-in",
            checkOut: "staff-check-out",
            getToday: "staff-attendance-today",
            getByStaff: "get-staff-attendance",
            getByDate: "get-staff-attendance-date",
            getWeeklyGraph: "staff-weekly-graph",
            getMonthlyStats: "staff-monthly-stats",
            getDashboard: "staff-attendance-dashboard",
            update: "update-staff-attendance",
            delete: "delete-staff-attendance",
            // Leave Management
            submitLeave: "submit-leave-request",
            getLeaveRequests: "get-leave-requests",
            approveLeave: "approve-leave",
            rejectLeave: "reject-leave",
            cancelLeave: "cancel-leave",
            getLeaveBalance: "get-leave-balance"
        },
        // Enhanced Fee Routes
        feesEnhanced: {
            getBalance: "get-fee-balance",
            getClassroomSummary: "get-classroom-fee-summary",
            recordPayment: "record-payment",
            initiateOnlinePayment: "initiate-online-payment",
            verifyPayment: "verify-payment",
            paymentWebhook: "payment-webhook",
            getPaymentHistory: "get-payment-history",
            generateReceipt: "generate-receipt",
            downloadReceipt: "download-receipt",
            applyDiscount: "apply-discount",
            applyWaiver: "apply-waiver",
            getOutstanding: "get-outstanding-fees",
            sendReminder: "send-fee-reminder",
            getCollectionStats: "fee-collection-stats"
        },
        // Enhanced Assignment Routes
        assignmentEnhanced: {
            getSubmissions: "get-assignment-submissions",
            getSubmission: "get-single-submission",
            getSubmissionDetails: "get-submission-details",
            submitAssignment: "submit-assignment",
            gradeSubmission: "grade-submission",
            bulkGrade: "bulk-grade-submissions",
            returnSubmission: "return-submission",
            returnForRevision: "return-for-revision",
            checkPlagiarism: "check-plagiarism",
            getRubric: "get-rubric",
            getRubrics: "get-rubrics",
            createRubric: "create-rubric",
            updateRubric: "update-rubric",
            deleteRubric: "delete-rubric",
            getStatistics: "assignment-statistics",
            getAssignmentStats: "assignment-statistics",
            grantExtension: "grant-extension",
            acceptLateSubmission: "accept-late-submission",
            publish: "publish-assignment",
            close: "close-assignment"
        },
        // Enhanced Lecture Routes
        lecturesEnhanced: {
            getMaterials: "get-lecture-materials",
            uploadMaterial: "upload-lecture-material",
            deleteMaterial: "delete-lecture-material",
            getNotes: "get-lecture-notes",
            addNote: "add-lecture-note",
            updateNote: "update-lecture-note",
            deleteNote: "delete-lecture-note",
            trackProgress: "track-lecture-progress",
            getLearnerProgress: "get-learner-lecture-progress",
            getAllProgress: "get-all-lecture-progress",
            markAttendance: "mark-lecture-attendance",
            getAttendance: "get-lecture-attendance",
            getStatistics: "get-lecture-statistics",
            getCourseProgress: "get-course-lecture-progress"
        }
    },
    dashboard: {
        login: "",
        home: "dashboard",
        classroom: {
            all: "classrooms",
            crud
        },
        teacher: {
            all: "teachers",
            crud
        },
        learner: {
            all: "learners",
            crud
        },
        course: {
            all: "courses",
            register: "register",
            crud
        },
        resource: {
            all: "resources",
            crud
        },
        lecture: {
            all: "lectures",
            crud
        },
        profile: "profile",
        explore: "explore",
        "academic-year": {
            all: "academic-years",
            crud
        },
        "academic-level": {
            all: "academic-levels",
            crud
        },
        exam: {
            all: "exams",
            crud
        },
        transaction: {
            all: "transactions",
            crud
        },
        project: {
            all: "projects",
            crud
        },
        task: {
            all: "tasks",
            crud
        },
        fee: {
            all: "fees",
            crud
        },
        activity: {
            all: "activities",
            crud
        },
        admins: "admins",
        myClass: "my-classroom",
        myOffice: "my-office",
        inbox: "inbox",
        promotion: "promotion"
    }
});

